import {
  AutocompleteRenderInputParams,
  Avatar,
  InputAdornment,
  InputBase,
  styled,
} from '@mui/material'
import { colorPalette } from '../../../style/colorPalette'
import { ReferencedEntityWithIcon } from '../../../../domain/value-object/ReferencedEntity'

export const renderOptionWithIcon = <Option extends ReferencedEntityWithIcon>(
  option: Option
) => {
  return (
    <OptionWithIconRoot>
      <StyledAvatar src={option.iconUrl} />
      <OptionName>{option.name}</OptionName>
    </OptionWithIconRoot>
  )
}
export const renderInputWithIcon = <Entity extends ReferencedEntityWithIcon>(
  params: AutocompleteRenderInputParams,
  value: Entity | undefined
) => {
  const startAdornment = value ? (
    <InputAdornment position="start">
      <StyledAvatar variant="circular" src={value?.iconUrl} />
    </InputAdornment>
  ) : undefined
  const InputProps = {
    ...params.InputProps,
    startAdornment,
  }
  return <TextInput {...InputProps} inputProps={params.inputProps} />
}
export const renderOption = <Entity extends ReferencedEntityWithIcon>(
  option: Entity
) => {
  return <OptionName>{option.name}</OptionName>
}
export const renderValueOnlyIcon = <Option extends ReferencedEntityWithIcon>(
  option: Option | undefined
) => {
  if (!option) return <></>
  return <StyledAvatar src={option.iconUrl} />
}

const TextInput = styled(InputBase)({
  width: '100%',
  color: colorPalette.monotone[10],
})
const StyledAvatar = styled(Avatar)({
  width: '20px',
  height: '20px',
})
const OptionName = styled('span')({
  color: colorPalette.monotone[10],
  fontSize: '12px',
})
const OptionWithIconRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})
